export const LOGO = "https://customer-assets-39nsmqrw.emergentagent.net/job_aru-releases/artifacts/36tstikf_ARU%20PNG%20LOGO.webp";
